import {useI18n} from 'store/Store'
import Texts from 'appearance/texts'
import YoutubeStatusSection from './YoutubeStatusSection'
import useYoutubeUploadStatus from 'logic/Dances/useYoutubeUploadStatus'
import {CircularProgress, Stack} from '@mui/material'

const YoutubeUploadStatus = () => {
    const {i18n} = useI18n()

    const {youtubeUploadStatus, isLoading} = useYoutubeUploadStatus()

    return (
        <Stack>
            <Texts.Subtitle>
                {i18n.t('dances.youtubeUploadStatus')}:
            </Texts.Subtitle>
            {isLoading ? (
                <CircularProgress size={16} />
            ) : (
                Object.keys(youtubeUploadStatus || {}).map((videoType) => (
                    <YoutubeStatusSection
                        key={videoType}
                        videoType={videoType}
                    />
                ))
            )}
        </Stack>
    )
}

export default YoutubeUploadStatus
